export default __webpack_public_path__ + "static/media/completeCircle.036d87c2.svg";